import algoliasearch from 'algoliasearch/lite';

const searchClient = algoliasearch('WPV3A7E5KL', '4a41bc07cda5d193f2ca64c9a85197cc');

export default searchClient;